// station-install: whether the signed-in account subscribed to a station (its Stations page
// grid). Not room membership: StationChat's subscribe is a different thing.
import { useEffect, useState } from 'react';

const url = (stationId) => `/api/subscriptions/${encodeURIComponent(stationId)}`;

// {subscribed, toggle, busy, error}; subscribed is null until known, and stays null when there
// is no station or no account, so the caller can hide the control. `error` is why the last
// toggle was refused (e.g. the subscription limit).
export default function useStationSubscription(stationId, signedIn) {
  const [subscribed, setSubscribed] = useState(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    setSubscribed(null);
    if (!stationId || !signedIn) return undefined;
    let cancelled = false;
    fetch(url(stationId), { credentials: 'include' })
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => { if (!cancelled && d) setSubscribed(Boolean(d.subscribed)); })
      .catch(() => {});
    return () => { cancelled = true; };
  }, [stationId, signedIn]);

  const toggle = async () => {
    if (busy || subscribed === null) return;
    setBusy(true);
    try {
      const r = await fetch(url(stationId), {
        method: subscribed ? 'DELETE' : 'PUT', credentials: 'include',
      });
      const d = await r.json().catch(() => null);
      if (r.ok && d) {
        setSubscribed(Boolean(d.subscribed));
        setError(null);
      } else {
        setError((d && d.error) || "That didn't work. Try again.");
      }
    } catch (_) {
      setError("That didn't work. Try again.");
    } finally {
      setBusy(false);
    }
  };

  return { subscribed, toggle, busy, error };
}
